import React, { Component, createRef, RefObject } from 'react'
import { isEmpty, isEqual } from 'lodash'
import googleApiUtil from '../utils/googleApi.util'

export interface MapCoordinate {
  lat: number
  lng: number
}

interface MapProps {
  coordinates: MapCoordinate[]
}

export default class Map extends Component<MapProps> {
  ref: RefObject<HTMLDivElement>

  constructor (props: MapProps) {
    super(props)
    this.ref = createRef()
  }

  get google () {
    return window.google
  }

  get mapOptions () {
    return {
      zoom: 4,
      center: this.props.coordinates[0]
    }
  }

  get lineOptions () {
    return {
      path: this.props.coordinates,
      strokeColor: '#10B981',
      strokeWeight: 3
    }
  }

  async initialize () {
    await googleApiUtil.initialize()
    const dom = this.ref.current
    if (!dom) return
    const map = new this.google.maps.Map(dom, this.mapOptions)
    const coordinatesLine = new this.google.maps.Polyline(this.lineOptions)
    coordinatesLine.setMap(map)
  }

  componentDidMount () {
    this.initialize()
  }

  componentDidUpdate (prevProps: MapProps) {
    const canInitialize = (
      !isEmpty(this.props.coordinates) &&
      !isEqual(prevProps.coordinates, this.props.coordinates)
    )
    if (canInitialize) this.initialize()
  }

  render () {
    return (
      <div
        className="h-52 w-full"
        ref={this.ref} />
    )
  }
}
